module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stat-indicator"
  }, [_c('div', {
    staticClass: "stat-indicator-ring",
    style: (_vm.box)
  }, [(_vm.showRing) ? _c('svg', {
    staticClass: "stat-indicator-svg-rot",
    attrs: {
      "width": _vm.size,
      "height": _vm.size
    }
  }, [_c('circle', {
    attrs: {
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "r": _vm.r,
      "stroke": _vm.trackColor,
      "stroke-width": _vm.stroke,
      "fill": "none"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "stat-indicator-ring-anim",
    attrs: {
      "cx": _vm.size / 2,
      "cy": _vm.size / 2,
      "r": _vm.r,
      "stroke": _vm.ringColor,
      "stroke-width": _vm.stroke,
      "fill": "none",
      "stroke-dasharray": _vm.dashArray,
      "stroke-dashoffset": _vm.dashOffset,
      "stroke-linecap": "round"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showSquare) ? _c('div', {
    staticClass: "stat-indicator-square",
    style: (("height: " + (_vm.size * 0.8) + "px; width: " + (_vm.size * 1.1) + "px"))
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stat-indicator-center"
  }, [_vm._v(_vm._s(_vm.centerText_computed) + _vm._s(_vm.suffix))])]), _vm._v(" "), _c('span', {
    staticClass: "stat-indicator-label"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b90016","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tools/StatIndicator.vue
// module id = 1650
// module chunks = 1